import { render, staticRenderFns } from "./DonutChart.vue?vue&type=template&id=113f9d23&scoped=true&"
import script from "./DonutChart.vue?vue&type=script&lang=js&"
export * from "./DonutChart.vue?vue&type=script&lang=js&"
import style0 from "./DonutChart.vue?vue&type=style&index=0&id=113f9d23&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "113f9d23",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('113f9d23')) {
      api.createRecord('113f9d23', component.options)
    } else {
      api.reload('113f9d23', component.options)
    }
    module.hot.accept("./DonutChart.vue?vue&type=template&id=113f9d23&scoped=true&", function () {
      api.rerender('113f9d23', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/monitoring/widgets/DonutChart.vue"
export default component.exports